import {
  LABEL_FLAG,
  LABEL_NAME,
} from '@doda/common/src/constants/seo/jobTrendConstants';

/**
 * 1～3位までのラベルを生成する処理。求人数多い順にソートされていることが前提。
 * @param label ラベル名
 * @param jobData
 * @param jobLabel
 * @param flg フラグ
 * @returns フラグに応じた文言に成型したラベル
 */
export const createRankingLabel = (
  jobData: number[],
  jobLabel: string[],
  flg: string
) => {
  let previousIndex: number;
  let joinLabel = '';
  const dataArray: number[] = [];
  const labelArray: string[] = [];
  const jobDataLength = jobData.length - 1;

  jobData.forEach((item, index) => {
    if (index === 0) {
      joinLabel = createLabelText(jobLabel[index], flg);
    } else if (previousIndex === item) {
      joinLabel += createLabelText(jobLabel[index], flg);
    } else {
      dataArray.push(previousIndex);
      labelArray.push(joinLabel);
      joinLabel = createLabelText(jobLabel[index], flg);
    }

    if (jobDataLength === index) {
      dataArray.push(item);
      labelArray.push(joinLabel);
    }

    previousIndex = item;
  });

  return dataArray.map((item, index) => [item, labelArray[index]]);
};

/**
 * フラグに応じた文言に成型したラベルを生成する処理
 * @param label ラベル名
 * @param flg フラグ
 * @returns フラグに応じた文言に成型したラベル
 */
export const createLabelText = (label: string, flg: string) => {
  let resultText;
  if (flg === LABEL_FLAG.EMPLOYEE_AVERAGE_AGE) {
    resultText = `「${LABEL_NAME.EMPLOYEE_AVERAGE_AGE}${label}」`;
  } else if (flg === LABEL_FLAG.ESTABLISH) {
    resultText = `「設立${label}」`;
  } else {
    resultText = `「${label}」`;
  }

  return resultText;
};
